import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';
import SearchField from '@adsk/alloy-react-search-field';
import theme from '@adsk/alloy-react-theme';

import { useCollection } from './providers/CollectionProvider';

const SheetSearchBox = ({ searchExpression, disabled, onSearchChange }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const { isFeatureEnabled: enableCollectionFeature } = useCollection();

  if (enableCollectionFeature) return null;

  return (
    <SearchField
      style={{
        width: 300,
        'input:disabled': {
          background: theme.colors.white,
        },
      }}
      placeholder={T.translate('SEARCH')}
      value={searchExpression || ''}
      onChange={onSearchChange}
      disabled={disabled}
    />
  );
};

SheetSearchBox.propTypes = {
  /**
   * input value
   */
  searchExpression: PropTypes.string,
  /**
   * whether it is disabled
   */
  disabled: PropTypes.bool,
  /**
   * callback when input value change
   */
  onSearchChange: PropTypes.func.isRequired,
};

export default SheetSearchBox;
